import { Link } from "@tanstack/react-router";

export function WhatsAppFloat() {
  return (
    <Link
      to="/blog"
      aria-label="Ler os artigos da Liderança com Valores"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-md bg-foreground px-4 py-3 text-sm font-semibold text-background shadow-lg transition-transform hover:-translate-y-0.5"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M4 4h16v12H5.5L4 17.5V4z" />
        <path d="M8 9h8M8 12h5" />
      </svg>
      <span className="hidden sm:inline">Ler artigos</span>
    </Link>
  );
}
